// extracted by mini-css-extract-plugin
export default {"wrapper":"BookingDetailsModal_wrapper__AwhEL","customFooter":"BookingDetailsModal_customFooter__vpJWX","exportButton":"BookingDetailsModal_exportButton__8D0LL"};